/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";

// required attributes
const PddBaseR = t.interface({
  description: t.string,

  enabled: t.boolean,

  ip: t.string
});

// optional attributes
const PddBaseO = t.partial({
  port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ])
});

export const PddBase = t.intersection([PddBaseR, PddBaseO], "PddBase");

export type PddBase = t.TypeOf<typeof PddBase>;
